export default (state) => {
    return state.config;
}



// WEBPACK FOOTER //
// ./src/ReduxRequests/State/configState.ts